import type { ReactNode } from 'react'

import type { Api, KeycloakState } from '@subaio/utils'

import type { UserAuth } from 'lib/store'

import { GridArea } from 'components/Layout'

import { Articles } from './Articles'
import { Container } from './Container'
import { Content } from './Content'
import { Footer } from './Footer'
import { Header } from './Header'
import { Main } from './Main'

const articlesWhitelist = ['Docs']

const pagesWithIndividualFooters = ['Apis']

type Props = {
	children: ReactNode
	pageName: string
	environment: string | null
	userAuth: UserAuth
	developerAuth: KeycloakState
	onLogout: () => void
	statuspageApi: Api
}

export const Page = ({ userAuth, pageName, developerAuth, onLogout, children, statuspageApi }: Props) => {
	const showArticles = articlesWhitelist.some((item) => pageName.split('/').some((name) => name === item))
	const hideFooter = pagesWithIndividualFooters.some((item) => pageName.split('/').some((name) => name === item))

	return (
		<Container showArticles={showArticles}>
			<Header developer={developerAuth.user} isLoginExpired={userAuth.status === 'expired'} onLogout={onLogout} />
			{showArticles && (
				<GridArea name='articles'>
					<Articles pageName={pageName} />
				</GridArea>
			)}
			<Main id='main'>
				<Content>{children}</Content>
				{!hideFooter && <Footer statuspageApi={statuspageApi} />}
			</Main>
		</Container>
	)
}
